<template>
    <div class="ConseilRecrutement">
        <HeadPage :title="'Recrutement et Intégration de salariés'" 
                  :category="'Conseil'"
                  :img="'conseil/recrutement.jpg'"
                  :imgAlt="'Recrutement head page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConseilRecrutement",
    data() {
        return {
            content: [
                { 
                    text: [ `Pour aider les entreprises à <strong>optimiser leur recrutement et l'intégration de nouveaux salariés</strong> (contrat d'apprentissage,
                    contrat de professionnalisation), <strong>JobStream</strong> propose des supports fiables d'aide à la décision et une approche innovante dans l'accompagnement.`
                    ]
                },
                {
                    title: 'Le recrutement', 
                    text: [`Nous disposons d'une <strong>gamme de tests adaptée</strong> au niveau de responsabilité, d'étude et 
                        de maîtrise de la langue :`,
                    `<ul>
                        <li>Tests de personnalité</li>
                        <li>Tests d'orientation</li>
                        <li>Test de raisonnement</li>
                    </ul>`
                    ]
                },
                {
                    title: 'L\'intégration', 
                    text: [`Le savoir être professionnel est un facteur clé d'une intégration réussie. L'approche
                    <strong>JobStream</strong> est fondée sur l'acculturation aux <strong>compétences comportementales</strong> 
                    attendues par l'entreprise :`,
                    `<ul>
                        <li>Faire des attitudes professionnelles un objet de formation.</li>
                        <li>Travailler sur des programmes élaborés à partir d'analyses de situation de travail.</li>
                        <li>Confronter la personne à des situations professionnelles réelles ou artificielles pour qu'une personne 
                        puisse en comprendre le sens.</li>
                        <li>Travailler sur les spécificités du milieu visé et des qualités que doivent posséder les personnes qui y exercent.</li>
                        <li>Travailler sur ce que la personne doit devenir professionnellement.</li>
                    </ul>`
                    ]
                }
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>